import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import VerifiedIcon from "@mui/icons-material/Verified";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CertificateDocument from "./CertificateDocument";
import { VERIFICACION_MUESTRA_PATH } from "../qr";

export default function CertificadoPreview({
  certificado,
  qrSvg,
  emitido,
  emitiendo,
  onEmitir,
  empresa,
  onEmpresaChange,
  normasText,
  onNormasChange,
}) {
  // QR / página pública: no integrados; el dominio es interno.
  // const [copiado, setCopiado] = useState(false);
  // const urlPublica = certificado?.folio ? verificacionUrl(certificado.folio) : "";
  //
  // useEffect(() => {
  //   if (!copiado) return undefined;
  //   const t = setTimeout(() => setCopiado(false), 2500);
  //   return () => clearTimeout(t);
  // }, [copiado]);
  //
  // const mensajeWhatsApp = useMemo(() => {
  //   if (!certificado || !urlPublica) return "";
  //   return `Hola, aquí está el certificado del servicio realizado el ${certificado.fecha} (folio ${certificado.folio}). Puedes verificarlo aquí: ${urlPublica}`;
  // }, [certificado, urlPublica]);
  //
  // const copiar = async () => {
  //   try {
  //     await navigator.clipboard.writeText(urlPublica);
  //     setCopiado(true);
  //   } catch {
  //     window.prompt("Copia el enlace de verificación:", urlPublica);
  //   }
  // };

  if (!certificado) {
    return (
      <Box sx={{ py: 10, textAlign: "center", px: 3 }}>
        <Typography sx={{ fontSize: 15, color: "#9ca3af" }}>
          Selecciona un servicio para ver el certificado.
        </Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={2.5}>
      <CertificateDocument certificado={certificado} qrSvg={qrSvg} />

      {!emitido && (
        <Box className="no-print" sx={{ border: "1px solid #e8eaef", borderRadius: "14px", p: 2.5, bgcolor: "#fafbfc" }}>
          <Typography sx={{ fontSize: 13, fontWeight: 650, color: "#111827", mb: 1.5 }}>
            Datos de la empresa
          </Typography>
          <Box sx={{ display: "grid", gap: 1.5, gridTemplateColumns: { sm: "1fr 1fr" } }}>
            <TextField
              size="small"
              label="Licencia o registro"
              value={empresa.licencia}
              onChange={(e) => onEmpresaChange({ ...empresa, licencia: e.target.value })}
            />
            <TextField
              size="small"
              label="Vigencia de la licencia"
              value={empresa.licenciaVigencia}
              onChange={(e) => onEmpresaChange({ ...empresa, licenciaVigencia: e.target.value })}
            />
          </Box>
          <TextField
            size="small"
            label="Normatividad aplicable"
            value={normasText}
            onChange={(e) => onNormasChange(e.target.value)}
            multiline
            minRows={3}
            fullWidth
            sx={{ mt: 1.5 }}
            helperText="Una norma por línea"
          />
          <Button
            fullWidth
            variant="contained"
            disabled={emitiendo}
            onClick={onEmitir}
            startIcon={emitiendo ? <CircularProgress size={16} color="inherit" /> : <VerifiedIcon />}
            sx={{
              mt: 2,
              height: 48,
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 650,
              bgcolor: "#111827",
              "&:hover": { bgcolor: "#1f2937" },
            }}
          >
            {emitiendo ? "Emitiendo certificado…" : "Emitir certificado"}
          </Button>
          <Typography sx={{ mt: 1.25, fontSize: 12, color: "#9ca3af", lineHeight: 1.5 }}>
            Solo se emite si el servicio ya tiene un reporte de plagas. El folio
            queda registrado de forma permanente.
          </Typography>
        </Box>
      )}

      {emitido && (
        <Box className="no-print" sx={{ border: "1px solid #e8eaef", borderRadius: "14px", p: 2.5 }}>
          <Typography
            sx={{
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: "0.2em",
              textTransform: "uppercase",
              color: "#9ca3af",
              mb: 1.5,
            }}
          >
            Entrega al cliente
          </Typography>
          <Stack spacing={1.25}>
            <Button
              fullWidth
              variant="contained"
              startIcon={<PrintIcon />}
              onClick={() => window.print()}
              sx={{
                height: 46,
                borderRadius: "12px",
                textTransform: "none",
                fontWeight: 650,
                bgcolor: "#111827",
                "&:hover": { bgcolor: "#1f2937" },
              }}
            >
              Descargar en PDF
            </Button>
            <Button
              fullWidth
              startIcon={<OpenInNewIcon />}
              href={VERIFICACION_MUESTRA_PATH}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ height: 44, borderRadius: "12px", textTransform: "none", color: "#6b7280" }}
            >
              Ver página de muestra
            </Button>
          </Stack>
          <Typography sx={{ mt: 1.5, fontSize: 12, color: "#9ca3af", lineHeight: 1.5 }}>
            El botón de PDF abre el diálogo de impresión: elige «Guardar como PDF».
          </Typography>
        </Box>
      )}
    </Stack>
  );
}
